import React, {useEffect, useState} from "react";
import MangeDashboard from "./MangeDashboard";
import {useMediaQuery} from "beautiful-react-hooks";
import {useAuthDispatch, useAuthState} from "../../Context/auth-context";
import axios from "axios";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { MdContentCopy } from "react-icons/md";
import { toast } from "react-toastify";
import { number } from "prop-types";
import { Link } from "react-router-dom";




export  default function Account () {

        const isSmall = useMediaQuery('(max-width: 768px)')
        const [isCopied, setIsCopied] = useState(false);

        const onCopyText = () => {
            setIsCopied(true);
            toast.dismiss()
            
            toast.warning(' کپی شد!', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });
    };
    const [phone,setphone] = useState()
    const  [meli,setmeli] = useState()
    const [name ,setName] = useState()
    const [ref,setRef] = useState()
    const [usercount,setUserCount] = useState(0)
    const  [cards,setCards] = useState([])
    const [firstLevel,setFirstLevel] = useState()
    const [secondLevel,setSecondLevel] = useState()




    const state = {
        'accepted': 'تایید شد',
        'rejected': 'رد شد',
        'waiting':'در انتظار'
    }



      const {isEhraz} = useAuthState()

       function  formatNumber(number){

       // let val = number.replace(/ /g, ' ').match(/.{1,4}/g).join("  ")

       const rawText = [...number.split(' ').join('')] // Remove old space
        const creditCard = [] // Create card as array
        rawText.forEach((t, i) => {
            if (i % 4 === 0 && i !== 0) creditCard.push(' ') // Add space
            creditCard.push(t)
        })
        return creditCard.join('') // Transform card array to string

        



        
      }


      function reverseString(str) {
        console.log(str)
        return str.split("").reverse().join("");
    }


    useEffect(()=>{
        axios.get('https://api.sinatether.com/Auth/GetDetailsAccount',{withCredentials:true}).then((res)=>{
            if (res.status == 200){

                setphone((res.data['phone']))
                setmeli(res.data['meli'])
                setName(res.data['name'])
                setRef(res.data['ref'])
                setUserCount(res.data['usersubcount'])
                setFirstLevel(res.data['first_identity_verified'])
                setSecondLevel(res.data['second_identity_verified'])


            }
        })
    },[])


    useEffect(()=>{
        axios.get('https://api.sinatether.com/Auth/GetRequestCarts/',{withCredentials:true}).then((res)=>{
            if (res.status == 200){

                setCards(res.data['cards'])

            }
        })
    },[])




    return(
        <MangeDashboard>


            {isSmall ?

                <div className={'main_orders mgtop3323'}>



                        <div className={'kfhshjgfus535623card'}>
                            <div className={' text-right border-bottom kdhsytdhsbfbs3434'}>
                          

                                <div className={'titlejw3 '}>اطلاعات حساب کاربری</div>

                            </div>

                            <div className="ptop1919">



                            <div className={'d-flex ptkernejfhsd43'}>
                                <div className={'title1919'}> نام و نام خانوادگی:</div>
                                <div className={'content1919'}>{name}</div>

                            </div>

                            <div className={'d-flex ptkernejfhsd43'}>
                                <div className={'title1919'}> کد ملی:</div>
                                <div className={'content1919'}>{meli}</div>

                            </div>


                            <div className={'d-flex ptkernejfhsd43'}>
                                <div className={'title1919 '}>شماره تلفن:</div>
                                <div className={'content1919'}>{phone}</div>



                            </div>

                            <div className={'d-flex ptkernejfhsd43 '}>
                                <div className={'title1919'}>  لینک دعوت دوستان:</div>
                                <div className={'content1919'}>


                                <CopyToClipboard text={ref} onCopy={onCopyText}>
                        <span className={'text-medium'}>
                           <MdContentCopy/></span>
                        </CopyToClipboard>

                        {ref}
                                
                                
                                
                                </div>

                            </div>

                            <div className={'d-flex ptkernejfhsd43'}>
                                <div className={'title1919'}>تعداد افراد دعوت شده (با تکمیل احراز هویت):</div>
                                <div className={'content1919'}>{usercount}</div>

                            </div>

                       

                            <div className={'d-flex ptkernejfhsd43'}>
                                <div className={'title1919'}> وضعیت احراز :</div>
                                {isEhraz && ( firstLevel || secondLevel) ?

                                <>

                                {firstLevel && secondLevel &&

                                <>
                                
                                <div className="sub-ewrjbwr2435242322 ">
                                <svg data-v-0ee97525="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" aria-labelledby="tick" class="mr-8-multi status-icon"><g transform="translate(-440 -242)"><rect width="24" height="24" transform="translate(440 242)" fill="rgba(0,0,0,0)"></rect><path d="M458.9,248.3a.99.99,0,1,1,1.4,1.4l-10.6,10.59a1,1,0,0,1-1.41,0l-4.19-4.19a.99.99,0,0,1,1.4-1.4l3.5,3.5Z" fill="#2dbd96"></path></g></svg>
                                <div className="confsje353535242 content1919 text-success-top">
                                    سطح یک 
                                </div>

                                </div>

                                <div className="sub-ewrjbwr2435242322">
                                <svg data-v-0ee97525="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" aria-labelledby="tick" class="mr-8-multi status-icon"><g transform="translate(-440 -242)"><rect width="24" height="24" transform="translate(440 242)" fill="rgba(0,0,0,0)"></rect><path d="M458.9,248.3a.99.99,0,1,1,1.4,1.4l-10.6,10.59a1,1,0,0,1-1.41,0l-4.19-4.19a.99.99,0,0,1,1.4-1.4l3.5,3.5Z" fill="#2dbd96"></path></g></svg>
                                <div className="confsje353535242 content1919 text-success-top">
                                    سطح دو
                                </div>
                                </div>

                                </>

                                }



                                {firstLevel && !secondLevel &&



                                    <>

                                <div className="sub-ewrjbwr2435242322 ">
                                <svg data-v-0ee97525="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" aria-labelledby="tick" class="mr-8-multi status-icon"><g transform="translate(-440 -242)"><rect width="24" height="24" transform="translate(440 242)" fill="rgba(0,0,0,0)"></rect><path d="M458.9,248.3a.99.99,0,1,1,1.4,1.4l-10.6,10.59a1,1,0,0,1-1.41,0l-4.19-4.19a.99.99,0,0,1,1.4-1.4l3.5,3.5Z" fill="#2dbd96"></path></g></svg>
                                <div className="confsje353535242 content1919 text-success-top">
                                    سطح یک 
                                </div>

                                </div>







                                
                                <div className="sub-ewrjbwr2435242322">

                                    <Link to={'/top-authentication'}>

                                    <button class="button-toa24324">ارتقا به سطح دو</button>

                                    </Link>
                                                                                
                                </div>

                                </>


                                }



                                                </>


                                    :
                                    <div className={' text-large text-danger content1919 '}>
                                                                                                                        احراز نشده

                                        <a href={'/fast-authentication'}>

                                        <button className={'btn btn-sor ml-2'}>احراز هویت</button>
                                        </a>


                                    </div>
                                }

                            </div>

                            </div>

                    

                      


                         


                           


                        </div>

                        
                    <div className={''}>

<div className={'row text-right  kdhsytdhsbfbs3434'}>
  

  <div className={'titlejw33 '}>کارتهای احراز شده</div>

</div>




    <div className={'ptop1919 d-flex over-x-auto'}>

        {cards ?

            cards.map((card) => (



                
    <div className={`card-bank2020 ${card['Authentication'] == 'accepted' && 'back-card-success'} ${card['Authentication'] == 'waiting' && 'back-card-yellow'} ${card['Authentication'] == 'rejected' && 'back-card-red'} `}>

    <div className="css6653733tit">
        {state[card['Authentication']]}
    </div>

    <div className="card-number-text">
        
        {formatNumber(card['cart_number'])}
    </div>

    <div className="sheba-text">
    {formatNumber(card['sheba_number'])}

    
    </div>

</div>





            ))


            :
            <span className={'text-muted text-large text-dark text-center'}>هیچ کارتی وجود ندارد</span>
        }





    </div>


</div>
             


                  
                </div>
                :
                <div className={'main_orders khghfdbshdtwt235542'}>


                    <div className={'row jheyghdbfbegrt5ff '}>
                            <div className={' border-bottom titsfknsfb435 '}>
                                    

                                    <div className={'titlejw3'}>اطلاعات حساب کاربری</div>

                                </div>

                                <div className="row padding-31">


                        <div className={'col-xl-6 col-md-6 border-left'}>
                           


                         


                            <div className={'d-flex ptkernejfhsd43'}>
                                <div className={'title1919'}> نام و نام خانوادگی:</div>
                                <div className={'content1919'}>{name}</div>

                            </div>

                            <div className={'d-flex ptkernejfhsd43'}>
                                <div className={'title1919'}> کد ملی:</div>
                                <div className={'content1919'}>{meli}</div>

                            </div>

                            
                            <div className={'d-flex ptkernejfhsd43'}>
                                <div className={'title1919'}> وضعیت احراز:</div>


                                {isEhraz && ( firstLevel || secondLevel) ?

<>

{firstLevel && secondLevel &&

<>

<div className="sub-ewrjbwr2435242322 ">
<svg data-v-0ee97525="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" aria-labelledby="tick" class="mr-8-multi status-icon"><g transform="translate(-440 -242)"><rect width="24" height="24" transform="translate(440 242)" fill="rgba(0,0,0,0)"></rect><path d="M458.9,248.3a.99.99,0,1,1,1.4,1.4l-10.6,10.59a1,1,0,0,1-1.41,0l-4.19-4.19a.99.99,0,0,1,1.4-1.4l3.5,3.5Z" fill="#2dbd96"></path></g></svg>
<div className="confsje353535242 content1919 text-success-top">
    سطح یک 
</div>

</div>

<div className="sub-ewrjbwr2435242322">
<svg data-v-0ee97525="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" aria-labelledby="tick" class="mr-8-multi status-icon"><g transform="translate(-440 -242)"><rect width="24" height="24" transform="translate(440 242)" fill="rgba(0,0,0,0)"></rect><path d="M458.9,248.3a.99.99,0,1,1,1.4,1.4l-10.6,10.59a1,1,0,0,1-1.41,0l-4.19-4.19a.99.99,0,0,1,1.4-1.4l3.5,3.5Z" fill="#2dbd96"></path></g></svg>
<div className="confsje353535242 content1919 text-success-top">
    سطح دو
</div>
</div>

</>

}



{firstLevel && !secondLevel &&



    <>

<div className="sub-ewrjbwr2435242322 ">
<svg data-v-0ee97525="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" aria-labelledby="tick" class="mr-8-multi status-icon"><g transform="translate(-440 -242)"><rect width="24" height="24" transform="translate(440 242)" fill="rgba(0,0,0,0)"></rect><path d="M458.9,248.3a.99.99,0,1,1,1.4,1.4l-10.6,10.59a1,1,0,0,1-1.41,0l-4.19-4.19a.99.99,0,0,1,1.4-1.4l3.5,3.5Z" fill="#2dbd96"></path></g></svg>
<div className="confsje353535242 content1919 text-success-top">
    سطح یک 
</div>

</div>








<div className="sub-ewrjbwr2435242322">

    <Link to={'/top-authentication'}>

    <button class="button-toa24324">ارتقا به سطح دو</button>

    </Link>
                                                
</div>

</>


}



                </>


    :
    <div className={' text-large text-danger content1919 '}>
                                                                                        احراز نشده

        <a href={'/fast-authentication'}>

        <button className={'btn btn-sor ml-2'}>احراز هویت</button>
        </a>


    </div>
}
                            

                            </div>


                            


                        </div>

                        <div className={'col-xl-6 col-md-6'}>
                        <div className={'d-flex ptkernejfhsd43'}>
                                <div className={'title1919 '}>شماره تلفن:</div>
                                <div className={'content1919'}>{phone}</div>

                            </div>


                            <div className={'d-flex ptkernejfhsd43'}>
                                <div className={'title1919'}>  لینک دعوت دوستان:</div>
                                <div className={'content1919'}>


                                <CopyToClipboard text={ref} onCopy={onCopyText}>
                        <span className={'text-ml'}>
                           <MdContentCopy/></span>
                        </CopyToClipboard>



                        {ref}
                                
                                
                                
                                </div>

                            </div>


                            <div className={'d-flex ptkernejfhsd43'}>
                                <div className={'title1919 '}>تعدادافراد دعوت شده فعال:</div>
                                <div className={'content1919'}>{usercount}</div>

                            </div>

                        </div>

                        </div>


                    </div>


                    <div className={'kfhshjgfus535623card jhhsahsds3343'}>

<div className={'row text-right  kdhsytdhsbfbs3434'}>
  

  <div className={'titlejw33 '}>کارت های احراز شده</div>

</div>




    <div className={'ptop1919 d-flex over-x-auto'}>

        {cards ?

            cards.map((card) => (



                
    <div className={`card-bank2020 ${card['Authentication'] == 'accepted' && 'back-card-success'} ${card['Authentication'] == 'waiting' && 'back-card-yellow'} ${card['Authentication'] == 'rejected' && 'back-card-red'} `}>

    <div className="css6653733tit">
        {state[card['Authentication']]}
    </div>

    <div className="card-number-text">
        
        {formatNumber(card['cart_number'])}
    </div>

    <div className="sheba-text">
    {formatNumber(card['sheba_number'])}

    
    </div>

</div>





            ))


            :
            <span className={'text-muted text-large text-dark text-center'}>هیچ کارتی وجود ندارد</span>
        }





    </div>


</div>
                 
                    
                </div>

            }


        </MangeDashboard>

    )

}